
const theMarketingAutomationSkillset = [
  {
    type: "heading",
    text: "The marketing automation skillset = Data Science + Creativity",
  },
  {
    type: "paragraph",
    text: "While many tools in the market don’t require in-depth technical skills, the ability to work with data is an essential requirement for today’s marketing team",
  },
  {
    type: "paragraph",
    text: "Automation isn’t just the realm of data scientists, but relies on a combination of art and science, a skillset that enables marketers to slice and dice the data, but also understand its business impact.",
  },
  {
    type: "paragraph",
    text: "The other needed skill is creativity, an ability to imagine beyond what can be seen or visible.",
  },

  {
    type: "paragraph",
    text: "We can let the machines run, aim for efficiency, test everything, and optimize, but we still need to inject new messaging, new creative, and different calls to action into our campaigns.",
  },
  {
    type: "paragraph",
    text: "That’s something we cannot outsource to the machine. It’s observed that it’s not typically one person that contains both skills, but rather, it’s the responsibility of a team or squad.",
  },

  {
    type: "heading",
    text: "A list of skills for the future published by The World Economic Forum includes",
  },

  {
    type: "list",
    items: [
      "Analytical Thinking Innovation",

      "Complex Problem Solving",

      "Creativity",

      "Originality",

      "Initiative",
    ],
  },
];

export default theMarketingAutomationSkillset;
